<template>
  <modal 
    name="end-agreement" 
    class="modal-inner" 
    transition="pop-out" 
    :width="modalWidth" 
    :focus-trap="true" 
    :min-height="400" 
    height="auto" 
    :scrollable="true" 
    :adaptive="true" 
    :reset="true"
    @before-open="beforeOpen"
  >
    <span class="close-button" @click="hide('end-agreement')">
      <BaseIcon icon="times-circle" class="text-white"/>
    </span>
    <div class="modal-header text-lg bg-primary-50 font-serif">
      {{ $t("end_agreement.title") }}
    </div>
    <div class="modal-body">
      <div v-if="isLoading" class="border border-gray-200 rounded-lg mt-3 py-3 px-3 font-sm text-gray-500 text-center">
        <BaseIcon icon="spinner" spin />
      </div>
      <div v-else class="space-y-4">
        <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <BaseIcon icon="exclamation-triangle" class="text-yellow-400" />
          </div>
          <div class="ml-3">
            <p class="text-sm text-yellow-700">
              {{ $t("end_agreement.info_text") }}
            </p>
          </div>
        </div>
      </div>
        <div class="form-group">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            {{ $t("end_agreement.description_label") }}
          </label>
          <textarea 
            v-model="description" 
            rows="6"
            class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
            :placeholder="$t('end_agreement.description_placeholder')"
          ></textarea>
        </div>

        <div class="flex justify-end gap-3 mt-6">
          <button 
            class="btn-secondary-outline" 
            @click="hide('end-agreement')"
          >
            {{ $t("user_actions.cancel") }}
          </button>
          <button 
            class="btn-green" 
            @click="submitEndAgreement"
            :disabled="isSubmitting"
          >
            <BaseIcon v-if="isSubmitting" icon="spinner" spin class="mr-2" />
            {{ $t("end_agreement.submit") }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>

const MODAL_WIDTH = 600


export default {
    props: {
        agreementNumber: {
            type: String,
            required: false,
            default: null
        }
    },

    data(){
        return {    
            isLoading: false,
            isSubmitting: false,
            description: '',
            currentAgreement: null
        };
    },
    
  computed: {
    modalWidth() {
      return MODAL_WIDTH;
    }
  },

  methods: {
    async beforeOpen(event){
        this.currentAgreement = event.params?.agreement;
        this.description = '';
    },

    async submitEndAgreement(){
        this.isSubmitting = true;
        try{
            const payload = {
                description: this.description.trim()
            };

            await this.axios.put(
                `${process.env.VUE_APP_SERVER_URL}/agreement/end-now/${this.currentAgreement._id}`,
                payload
            )

            this.handleSuccess(this.$t('end_agreement.success_message'));
            this.$emit('agreement-ended');
            this.hide('end-agreement');
        }catch(error){
            this.handleError(error);
        }finally{
            this.isSubmitting = false;
        }
    },
    hide(id) {
      this.$modal.hide(id);
    }
  }
}


</script>